import type { FC } from 'react';
import { Box } from '@mui/material';
import { FieldArray, useFormikContext } from 'formik';

import type { SurveyDetailUpdate } from 'src/types/survey';

import AddNewRootCause from './AddNewRootCause';
import EditRootCauseWarning from './EditRootCauseWarning';
import RootCauseEdit from './RootCauseEdit';

import { styles } from 'src/components/survey/SurveySettings/index.styles';

const RootCausesSettings: FC = () => {
  const { values } = useFormikContext<SurveyDetailUpdate>();

  return (
    <Box sx={styles.rootCausesSettings}>
      <FieldArray
        name="specificSettings.followUp.rootCauses"
        render={({ unshift }) => (
          <>
            <AddNewRootCause
              unshift={unshift}
              rootCauses={[
                ...(values.specificSettings.followUp?.rootCauses ?? []),
              ]}
            />
            <EditRootCauseWarning />
            <Box sx={styles.followUpEditsContainer}>
              {values.specificSettings.followUp?.rootCauses.map(
                (rootCause, index) => (
                  <RootCauseEdit
                    key={rootCause.id}
                    {...rootCause}
                    index={index}
                  />
                ),
              )}
            </Box>
          </>
        )}
      />
    </Box>
  );
};

export default RootCausesSettings;
